function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Skeleton, message, Descriptions, Button } from 'antd';
import Common from "./includes/Common";
import { Container, Row, Col } from 'react-bootstrap';
import { GenderMale, GenderFemale, CardChecklist, HospitalFill } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var PatientView = function PatientView(_ref) {
  var pid = _ref.pid;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    patient = _useState2[0],
    setPatient = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  useEffect(function () {
    axios.get(Common.baseApiUrl + "getcustomerbyid/" + pid.toString() + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setPatient(response.data.patient);
      } else {
        message.error({
          content: response.data.message,
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [pid]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
      active: true
    }), patient != null && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsxs(Col, {
            lg: 3,
            md: 3,
            sm: 2,
            xs: 2,
            children: [patient.gender == 'F' && /*#__PURE__*/_jsx(GenderFemale, {
              size: 35
            }), patient.gender == 'H' && /*#__PURE__*/_jsx(GenderMale, {
              size: 35
            })]
          }), /*#__PURE__*/_jsxs(Col, {
            lg: 9,
            md: 9,
            sm: 10,
            xs: 10,
            children: [/*#__PURE__*/_jsxs(Descriptions, {
              column: 2,
              title: "Informations personelles",
              children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                labelStyle: {
                  fontWeight: 'Bold'
                },
                span: 2,
                contentStyle: {
                  fontWeight: 'Bold'
                },
                label: "ID PATIENT",
                children: patient.idnumber
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: "Pr\xE9nom",
                children: patient.firstname
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: "Nom",
                children: patient.lastname
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: "Tel.",
                children: patient.mobile
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: "Genre",
                children: patient.gender
              })]
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Button, {
              type: "primary",
              style: {
                margin: '5px'
              },
              onClick: null,
              icon: /*#__PURE__*/_jsx(CardChecklist, {
                size: 26
              }),
              size: "middle",
              children: "Prescrire un bilan"
            }), /*#__PURE__*/_jsx(Button, {
              type: "primary",
              onClick: null,
              icon: /*#__PURE__*/_jsx(HospitalFill, {
                size: 26
              }),
              size: "middle",
              children: "Hospitaliser"
            })]
          })]
        })
      })
    })]
  });
};
export default PatientView;